import MainHeader from '@/components/MainHeader';
import Navigation from '@/components/Navigation';
import Footer from '@/components/Footer';
import SEOHead from '@/components/SEOHead';
import { BreadcrumbSchema } from '@/components/SchemaOrg';

const TerminiCondizioni = () => {
  return (
    <>
      <SEOHead
        title="Termini e Condizioni | Materialidtf.it"
        description="Termini e condizioni di vendita di Materialidtf.it. Leggi le condizioni generali per gli acquisti sul nostro e-commerce."
        canonical="/termini-condizioni"
        noindex={false}
      />
      <BreadcrumbSchema
        items={[
          { name: 'Home', url: '/' },
          { name: 'Termini e Condizioni', url: '/termini-condizioni' }
        ]}
      />

      <MainHeader />
      <Navigation />

      <main className="min-h-screen bg-background py-16 px-4">
        <div className="container mx-auto max-w-4xl">
          <h1 className="text-4xl font-bold text-foreground mb-8">Termini e Condizioni</h1>
          
          <div className="prose prose-lg max-w-none text-muted-foreground space-y-6">
            <p className="text-sm text-muted-foreground">
              Ultimo aggiornamento: Gennaio 2025
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">1. Informazioni Generali</h2>
              <p>
                Il presente documento regola le condizioni generali di vendita dei prodotti offerti sul sito Materialidtf.it. L'acquisto di prodotti sul sito implica l'accettazione integrale delle presenti condizioni.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">2. Prodotti</h2>
              <p>
                I prodotti offerti sono materiali per stampa DTF professionale, inclusi inchiostri, bobine, colla, polvere adesiva, ricambi e accessori. Le immagini e le descrizioni dei prodotti sono indicative e possono differire leggermente dal prodotto reale.
              </p>
              <p className="mt-4">
                I prezzi indicati sono in Euro (€) e si intendono IVA esclusa, salvo diversa indicazione. Il venditore si riserva il diritto di modificare i prezzi in qualsiasi momento.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">3. Ordini</h2>
              <p>
                L'ordine costituisce una proposta contrattuale di acquisto. Il contratto si considera concluso quando il cliente riceve la conferma d'ordine via email.
              </p>
              <p className="mt-4">
                Il venditore si riserva il diritto di rifiutare ordini provenienti da clienti con cui esistono controversie legali o che abbiano in precedenza violato le presenti condizioni.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">4. Pagamenti</h2>
              <p>Sono accettate le seguenti modalità di pagamento:</p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>Bonifico bancario anticipato</li>
                <li>Carta di credito/debito</li>
                <li>PayPal</li>
                <li>Contrassegno (con supplemento)</li>
              </ul>
              <p className="mt-4">
                In caso di pagamento con bonifico, l'ordine verrà evaso solo dopo l'accredito effettivo sul conto del venditore.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">5. Spedizioni</h2>
              <p>
                Le spedizioni vengono effettuate tramite corriere espresso. I tempi di consegna indicati sono puramente indicativi e non vincolanti. Il venditore non è responsabile per ritardi imputabili al corriere.
              </p>
              <p className="mt-4">
                Le spese di spedizione sono a carico del cliente, salvo promozioni specifiche. La spedizione gratuita è disponibile per ordini superiori a determinati importi, come indicato sul sito.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">6. Diritto di Recesso</h2>
              <p>
                Ai sensi del D.Lgs. 206/2005 (Codice del Consumo), il consumatore ha diritto di recedere dal contratto entro 14 giorni dalla ricezione della merce, senza dover fornire alcuna motivazione.
              </p>
              <p className="mt-4">
                Il diritto di recesso non si applica a:
              </p>
              <ul className="list-disc pl-6 space-y-2 mt-4">
                <li>Prodotti sigillati aperti dopo la consegna</li>
                <li>Prodotti confezionati su misura o personalizzati</li>
                <li>Prodotti che rischiano di deteriorarsi rapidamente</li>
              </ul>
              <p className="mt-4">
                Per esercitare il diritto di recesso, il cliente deve inviare una comunicazione scritta a: recesso@materialidtf.it
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">7. Garanzia</h2>
              <p>
                Tutti i prodotti sono coperti dalla garanzia legale di conformità prevista dal Codice del Consumo (24 mesi per i consumatori, 12 mesi per i professionisti).
              </p>
              <p className="mt-4">
                Il cliente deve denunciare eventuali difetti di conformità entro 2 mesi dalla scoperta. La garanzia non copre danni derivanti da uso improprio, negligenza o normale usura.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">8. Limitazione di Responsabilità</h2>
              <p>
                Il venditore non è responsabile per danni indiretti, perdite di profitto o danni conseguenti derivanti dall'utilizzo dei prodotti. La responsabilità massima del venditore è limitata al valore dell'ordine.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">9. Proprietà Intellettuale</h2>
              <p>
                Tutti i contenuti del sito (testi, immagini, loghi, grafica) sono di proprietà esclusiva di Materialidtf.it e sono protetti dalle leggi sul diritto d'autore. È vietata la riproduzione senza autorizzazione scritta.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">10. Legge Applicabile e Foro Competente</h2>
              <p>
                Il presente contratto è regolato dalla legge italiana. Per qualsiasi controversia derivante dall'interpretazione o esecuzione delle presenti condizioni, sarà competente il Foro del luogo di residenza del consumatore. Per i clienti professionisti, sarà competente il Foro di Roma.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">11. Contatti</h2>
              <p>
                Per qualsiasi domanda relativa alle presenti condizioni, è possibile contattarci a:
              </p>
              <ul className="list-none mt-4 space-y-2">
                <li><strong>Email:</strong> info@materialidtf.it</li>
                <li><strong>Telefono:</strong> +39 375 7190556</li>
              </ul>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default TerminiCondizioni;
